<template>
  <div>
    <div v-html="html_footer"></div>
    <div class="footer_nav01N"></div>
    <div class="footer_nav02">
      <div class="wrap1200">
        <a
          @click="pushOld('tourism/tourism_product.jsp?part_enname=chujingyou&init=1&ordinary_search=1')"
          class="bg1"
          href="javascript:void(0);"
        >
          出境游
          <i></i>
        </a>
        <a
          @click="pushOld('tourism/tourism_product.jsp?part_enname=guoneiyou&init=1&ordinary_search=1')"
          class="bg2"
          href="javascript:void(0);"
        >
          国内游
          <i></i>
        </a>
        <a
          @click="pushOld('tourism/tourism_product.jsp?part_enname=shengneiyou&init=1&ordinary_search=1')"
          class="bg3"
          href="javascript:void(0);"
        >
          省内游
          <i></i>
        </a>
        <a
          @click="pushOld('tourism/tourism_product.jsp?part_enname=youlun&init=1&ordinary_search=1')"
          class="bg4"
          href="javascript:void(0);"
        >
          邮轮
          <i></i>
        </a>
        <a
          @click="pushOld('tourism/tourism_product.jsp?part_enname=taiwanyou&init=1&ordinary_search=1')"
          class="bg5"
          href="javascript:void(0);"
        >
          台湾游
          <i></i>
        </a>
        <a
          @click="pushOld('tourism/tourism_product.jsp?part_enname=gangaoyou&init=1&ordinary_search=1')"
          class="bg6"
          href="javascript:void(0);"
        >
          港澳游
          <i></i>
        </a>
        <a
          @click="pushOld('tourism/tourism_product.jsp?part_enname=haidao&init=1&ordinary_search=1')"
          class="bg7"
          href="javascript:void(0);"
        >
          海 岛
          <i></i>
        </a>
        <a @click="$pushByName('visaProduct')" class="bg8" href="javascript:void(0);">签 证</a>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BottonNavigation',
  componentName: 'BottonNavigation',
  data () {
    return {
      footer_nav01_url: 'webpart/images_pc/footer_logo',
      html_footer: ''
    }
  },
  created () {
    this.$myGet(this.footer_nav01_url)
      .then(res => {
        this.html_footer = res.response.data.imgUrls
      })
      .catch(err => {
        this.$msg('[' + err.status + ']' + err.message)
      })
  },
  methods: {
    pushOld (url) {
      window.location.href = this.$getOldWebUrl() + url
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/components/bottonNavigation.vue